import { Injectable } from '@angular/core';
import { BaseHttpService } from '../base-http/base-http.service';
import { catchError, map, throwError } from 'rxjs';
import { IGenericResponse } from 'src/app/common/interface/generic-response.interface';
import { SharedService } from '../shared.service';

const AUTONOMOUS_TESTING = 'autonomous-testing';

@Injectable({
  providedIn: 'root',
})
export class AskMeService {
  constructor(
    private readonly httpService: BaseHttpService,
    private sharedService: SharedService
  ) {}

  /**
   * Retrieves the current chat session from the autonomous testing service.
   *
   * @returns Observable containing session data if successful.
   */
  getSession = () => {
    const url =
      `${AUTONOMOUS_TESTING}/get-chat-session` +
      `?askMeChatBot=true`;
    
    return this.httpService.get(url).pipe(
      map((res: IGenericResponse) => {
        if (res?.status === 200) return res.data;
      }),
      catchError((error) => {
        return throwError(() => error);
      })
    );
  };

  /**
   * Sends a question to the autonomous testing service and saves the mapping.
   *
   * @param question The question to ask.
   * @param sessionId The session identifier.
   * @param time The date and time of the request.
   * @returns Observable containing the response data if successful.
   */
  askMe = (question: string, sessionId: string, time: string, llmModel: string, reasoningParameter: string) => {
    let requestObj = {
      question: question,
      sessionId: sessionId,
      dateTime: time,
      llmModel,
      reasoningParameter
    };

    return this.httpService
      .post(`${AUTONOMOUS_TESTING}/add-conversation`, requestObj, true)
      .pipe(
        map((res: IGenericResponse) => {
          if (res?.status == 200) return res.data;
        }),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  };

  /**
   * Deletes a chat session from the autonomous testing service.
   *
   * @param sessionId The session identifier to delete.
   * @returns Observable containing the response data if successful.
   */
  deleteSession = (sessionId: string) => {
    let requestObj = {
      sessionId: sessionId,
    };

    return this.httpService
      .delete(`${AUTONOMOUS_TESTING}/delete-conversation`, requestObj)
      .pipe(
        map((res: IGenericResponse) => {
          if (res?.status == 200) return res.data;
        }),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  };
}
